export const entries = <O extends Record<string, unknown>>(obj: O) =>
  (Object.entries(obj) as unknown) as { [K in keyof O]: [K, O[K]] }[keyof O][]
